/**
 * Specifies the source of the price(s) of the security used in the calculation of the metrics or analytics data.
 * tag: 2993
 * @readonly
 * @enum {number} (int)
 */
export enum MetricsCalculationPriceSource {
  Realtime = 1,
  EndOfDay = 2,
}
